import { render, staticRenderFns } from "./ModalCreateAllInvoices.vue?vue&type=template&id=bb4b1068"
import script from "./ModalCreateAllInvoices.vue?vue&type=script&lang=js"
export * from "./ModalCreateAllInvoices.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports